import { Component } from "react";

/**
 * Tiny error boundary for lottie-react.
 *
 * lottie-web dispatches `AbortError: signal is aborted without reason`
 * from its internal AbortController when the component unmounts before
 * an internal image/frame fetch completes. This is harmless (the
 * animation just stops), but React 19's dev overlay catches it as an
 * uncaught runtime error, and on some mobile browsers the unhandled
 * abort blanks the page.
 *
 * Wrapping the Lottie player with this boundary contains any failure
 * to the animation layer — the branded tier chrome (label, amount,
 * tipper) always still renders.
 */
export default class LottieBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(err) {
    // Swallow. `AbortError` on unmount is expected. Log others for triage.
    if (err?.name !== "AbortError") {
      console.warn("[LottieBoundary]", err?.message);
    }
  }

  render() {
    if (this.state.failed) return null;
    return this.props.children;
  }
}
